export default "__VITE_ASSET__CcnSDLXH__"